export interface UpdateOrderListRequest {
  id: string
  displayMemo: string
  selectionReason: string
  traderCode: string
  acceptType: string
  departmentCode: string
  donorCode: string
  budgetYear: number | string
  budgetBranchCode: string
  budgetDepartmentCode: string
  budgetExpenseCode: string
  equipType: string
  collectionType: string
  shelfType: string
  handlingType: string
  orderNumbers: {
    orderBranchCode: string
    orderNumber: number | string
  }[]
  tooliFlag: boolean
  tooliCustomerId: string
  tooliOrderType: string
  materialFormatCode: string
  revision: number
}

export function UpdateOrderListRequestToJSON(
  value: UpdateOrderListRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    display_memo: value.displayMemo !== '' ? value.displayMemo : undefined,
    selection_reason:
      value.selectionReason !== '' ? value.selectionReason : undefined,
    trader_code: value.traderCode !== '' ? value.traderCode : undefined,
    accept_type: value.acceptType !== '' ? value.acceptType : undefined,
    department_code:
      value.departmentCode !== '' ? value.departmentCode : undefined,
    donor_code: value.donorCode !== '' ? value.donorCode : undefined,
    budget_year: value.budgetYear !== '' ? value.budgetYear : undefined,
    budget_branch_code:
      value.budgetBranchCode !== '' ? value.budgetBranchCode : undefined,
    budget_department_code:
      value.budgetDepartmentCode !== ''
        ? value.budgetDepartmentCode
        : undefined,
    budget_expense_code:
      value.budgetExpenseCode !== '' ? value.budgetExpenseCode : undefined,
    equip_type: value.equipType !== '' ? value.equipType : undefined,
    collection_type:
      value.collectionType !== '' ? value.collectionType : undefined,
    shelf_type: value.shelfType !== '' ? value.shelfType : undefined,
    handling_type: value.handlingType !== '' ? value.handlingType : undefined,
    order_numbers:
      value.orderNumbers.length !== 0
        ? value.orderNumbers.map(value => {
            return {
              order_branch_code:
                value.orderBranchCode !== ''
                  ? value.orderBranchCode
                  : undefined,
              order_number:
                value.orderNumber !== '' ? value.orderNumber : undefined
            }
          })
        : undefined,
    tooli_flag: value.tooliFlag ?? undefined,
    tooli_customer_id:
      value.tooliCustomerId !== '' ? value.tooliCustomerId : undefined,
    tooli_order_type:
      value.tooliOrderType !== '' ? value.tooliOrderType : undefined,
    material_format_code:
      value.materialFormatCode !== '' ? value.materialFormatCode : undefined,
    revision: value.revision ? value.revision : undefined
  }
}
